var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.selectClasss },
    [
      _c(
        "div",
        {
          ref: "mkuSelect",
          staticClass: "mku-select__inner",
          on: {
            mouseover: function($event) {
              return _vm.handleMouseHover(true)
            },
            mouseout: function($event) {
              return _vm.handleMouseHover(false)
            },
            click: _vm.handleSelectClick
          }
        },
        [
          _vm.optionsSelected.length
            ? [
                !_vm.multiple
                  ? _c(
                      "div",
                      { staticClass: "mku-select__txt mku-global-ellipsis" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.optionsSelected[0] &&
                                _vm.optionsSelected[0].text
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "mku-select__labels" },
                      _vm._l(_vm.optionsSelected, function(item, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass: "mku-select__labels-item"
                          },
                          [
                            _c("span", { staticClass: "mku-global-ellipsis" }, [
                              _vm._v(_vm._s(item.text))
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "mku-icon mku-icon-error-circle",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDelete(item)
                                }
                              }
                            })
                          ]
                        )
                      }),
                      0
                    )
              ]
            : _c(
                "div",
                { staticClass: "mku-select__placeholder mku-global-ellipsis" },
                [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
              ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "mku-select__icon", on: { click: _vm.handleClear } },
            [
              _c("i", {
                class: [
                  "mku-icon",
                  _vm.isShowClearIcon
                    ? "mku-icon-error-circle"
                    : "mku-icon-arrow-down"
                ]
              })
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "mku-select-dropdown" } }, [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpened && !_vm.disabled,
                expression: "isOpened && !disabled"
              }
            ],
            ref: "mkuSelectMenu",
            staticClass: "mku-select__menu",
            style: _vm.dropdownStyle,
            on: { click: _vm.handleDropdownClick }
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }